<template>
	<div class="_pagina_statistiche_squadre">

		<div class="d-flex flex-column" style="margin: 0 30px 20px;">
			<div data-tour-step-statistiche="1" class="_semi_bold mb-2"
					 style="color:#434343; font-size:25px;">
				Statistiche Squadr{{ idSquadra == undefined ? 'e' : 'a' }}
			</div>

			<div data-tour-step-statistiche="3" class="d-flex align-center">
				<div class="_semi_bold" style="font-size:18px; margin-right:25px;">Seleziona il periodo
					<v-icon :style="`margin-left:5px; font-size:20px; color:${scdColor}`">event</v-icon>
				</div>
				<div style="margin-right:25px;">
					<v-menu
						ref="dal"
						v-model="menuDal"
						:close-on-content-click="false"
						transition="scale-transition"
						offset-y
						max-width="290px"
						min-width="90px"
					>
						<template v-slot:activator="{ on }">
							<div class="d-flex align-center">
								<div style="font-size:18px;">Dal</div>
								<v-text-field class="input_seleziona_periodo" style="width:120px; padding-left:7px;" :color="scdColor"
															clearable @click:clear="dateDal = null" readonly :value="dateITFormat(dateDal)"
															v-on="on"></v-text-field>
							</div>

						</template>
						<v-date-picker :color="scdColor" locale="it" v-model="dateDal" no-title
													 @input="menuDal = false"></v-date-picker>
					</v-menu>
				</div>
				<div style="margin-right:25px;">
					<v-menu
						ref="al"
						v-model="menuAl"
						:close-on-content-click="false"
						transition="scale-transition"
						offset-y
						max-width="290px"
						min-width="90px"
					>
						<template v-slot:activator="{ on }">
							<div class="d-flex align-center">
								<div style="font-size:18px;">Al</div>
								<v-text-field class="input_seleziona_periodo" style="width:120px; padding-left:7px;" :color="scdColor"
															readonly clearable @click:clear="dateAl = null" :value="dateITFormat(dateAl)"
															v-on="on"></v-text-field>
							</div>
						</template>
						<v-date-picker :color="scdColor" locale="it" v-model="dateAl" no-title
													 @input="menuAl = false"></v-date-picker>
					</v-menu>
				</div>
			</div>

			<div data-tour-step-statistiche="2" v-if="idSquadra === undefined" class="d-flex justify-end align-center" style="width:549px;">
				<div class="_semi_bold" style="font-size:18px; margin-right:25px;">Seleziona la squadra</div>
				<v-autocomplete v-model="idSquadraSelezionata" item-value="id" item-text="nome" :items="squadre" :loading="isLoadingSquadre"/>
			</div>

			<div class="d-flex align-center" style="width:715px;">
				<div class="_semi_bold" style="font-size:18px; margin-right:25px;">Scegli il bando</div>
				<v-select
					style="margin-right:25px;"
					item-text="nome"
					item-value="id"
					:items="bandi"
					v-model="bandoId"
					placeholder="Seleziona"
					:loading="isLoadingBandi"
				></v-select>
				<v-btn depressed :color="scdColor" class="_semi_bold"
							 style="color:white; text-transform:none; letter-spacing:1px; padding:0 30px;" rounded
							 @click="getStatsSquadra()">Conferma
				</v-btn>
			</div>
		</div>

		<v-row v-if="isLoadingSquadre || isLoadingStats" justify="center">
			<v-progress-circular class="mt-12" :color="scdColor" size="32" width="3" indeterminate></v-progress-circular>
		</v-row>
		<div v-else>
			<div style="background-color:white;">
				<v-row style="padding: 20px 50px;">
					<v-col style="margin-top:15px;" sm="4" data-tour-step-statistiche="4">
						<v-row style="color:#434343" class="_semi_bold">Tempo medio:<span
							:style="`color:${scdColor}; margin-left:5px;`">{{ !isNaN(tempoMedioComplessivo) ? tempoMedioComplessivo + "s" : "-" }}</span>
						</v-row>
						<v-row style="color:#434343" class="mb-3 _semi_bold">Simulazioni eseguite:<span
							:style="`color:${scdColor}; margin-left:5px;`">{{ numSimulazioniComplessive }}</span></v-row>
						<chart-pie-component :height="220" :chartData="pieChart"/>
					</v-col>
					<v-col sm="8">
						<chart-line-component
							:key="lineChartKey"
							data-tour-step-statistiche="5"
							:chartData="dataLineChart"
							:height="300"
							:options="options"
						/>
					</v-col>
				</v-row>
			</div>

			<v-row class="mt-2">
				<v-col cols="6" md="4" class="mx-6">
					<v-text-field autocomplete="search-cliccatore" label="Cerca cliccatore" v-model="search"
												prepend-icon="search"/>
				</v-col>
			</v-row>

			<v-data-table
				data-tour-step-statistiche="6"
				class="mt-0 mx-2 mb-2 statistiche-data-table"
				:headers="headers"
				:items="tableStatsCliccatore"
				no-data-text="Nessun cliccatore trovato"
				:footer-props="{'items-per-page-options':[5, 15, 30], 'items-per-page-text': 'Cliccatori per pagina'}"
				:search="search"
			>
				<template slot="item" slot-scope="props">
					<tr class="_table_row">
						<td>{{ props.item.classifica }}</td>
						<td>{{ props.item.username }}</td>
						<td style="color:white;"
								:class="`_semi_bold ${props.item.tempoMedio <= tempoDaBattere && props.item.tempoMedio != null ? ' bg_green' : (props.item.tempoMedio > tempoDaBattere && props.item.tempoMedio != null ? ' bg_red' : '')}`">
							{{ props.item.tempoMedio ? props.item.tempoMedio + " s" : "" }}
						</td>
						<td>{{ props.item.numSimulazioniEseguite }}</td>
						<td>{{ props.item.percVincenti + "% (" + props.item.numVincenti + ")" }}</td>
						<td>{{ props.item.percAbbandonate + "% (" + props.item.numAbbandonate + ")" }}</td>
						<td>
							<v-switch
								v-if="props.item.numSimulazioniEseguite >= 60"
								class="mt-0" inset hide-details
								:disabled="idsCliccatoriDaMostrare.length == limitCliccatoriDaMostrare && !idsCliccatoriDaMostrare.includes(props.item.utenteId)"
								:color="colorsCliccatoriDaMostrare[idsCliccatoriDaMostrare.indexOf(props.item.utenteId)]"
								v-model="props.item.checkbox_value"
								@change="mostraNascondiGraficoCliccatore(props.item.utenteId)"></v-switch>
						</td>
						<td>
							<v-tooltip bottom>
								<template v-slot:activator="{ on }">
									<v-btn :color="scdColor" small rounded depressed
												 :style="`text-transform:none; color:white; letter-spacing:0.5px; padding:0 30px;`"
												 @click="showStatsCliccatore(props.item.utenteId)" v-on="on">
										Statistiche
									</v-btn>
								</template>
								<span>Visualizza le statistiche del cliccatore</span>
							</v-tooltip>
						</td>
					</tr>
				</template>
				<template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
					{{ pageStart }} - {{ pageStop }} di {{ itemsLength }}
				</template>
			</v-data-table>
		</div>

		<v-dialog v-model="isCliccatoreStatsDialogOpen" max-width="1600">
			<v-card>
				<v-card-title class="headline">
					<!--<span class="ml-4">Statistiche Cliccatore</span>-->
					<v-spacer></v-spacer>
					<v-btn color="black--text" icon @click="isCliccatoreStatsDialogOpen = false">
						<v-icon>close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<statistiche-cliccatore-component
						v-if="isCliccatoreStatsDialogOpen"
						:idCliccatore="idCliccatoreDaMostrareStats"
						:hideGuide="true"
					/>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						:color="scdColor"
						class="mr-4 mb-3 px-5 white--text"
						@click="isCliccatoreStatsDialogOpen = false"
						depressed
						rounded
					>
						Chiudi
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>


<script>
import mixin from '../../mixins';

export default {
	props: ['hideGuide', 'idSquadra'],
	data() {
		return {
			menuDal: null,
			dateDal: moment().subtract(6, 'days').format('YYYY-MM-DD'),
			menuAl: null,
			dateAl: moment().format('YYYY-MM-DD'),

			isLoadingBandi: false,
			bandi: [],
			bandoId: null,

			search: null,

			isLoadingSquadre: false,
			squadre: [],
			idSquadraSelezionata: null,

			isLoadingStats: false,

			pieChart: [],

			headers: [
				{text: '', value: 'classifica', searchable: false},
				{text: 'Cliccatore', value: 'username'},
				{text: 'Tempo Medio', value: 'tempoMedio', searchable: false},
				{text: 'Simulazioni eseguite', value: 'numSimulazioniEseguite', searchable: false},
				{text: 'Simulazioni vincenti', value: 'percVincenti', searchable: false},
				{text: 'Simulazioni abbandonate', value: 'percAbbandonate', searchable: false},
				{text: 'Mostra nel grafico', value: 'show_chart', sortable: false, searchable: false},
				{text: 'Azioni', value: 'action', sortable: false, searchable: false},
			],

			originalDatasets: [],
			lineChartKey: 0,
			dataLineChart: null, // Per il grafico
			options: {},

			tableStatsCliccatore: [], // Per la tabella

			tempoDaBattere: null,
			tempoMedioComplessivo: null,
			numSimulazioniComplessive: null,
			numSimulazioniVinteComplessive: null,
			numSimulazioniAbbandonateComplessive: null,

			tempiMediSquadra: [],
			tempiMediAzienda: [],
			tempiMediCliccatoriSquadra: [],

			// Per i cliccatori da mostrare dinamicamente nel grafico:
			limitCliccatoriDaMostrare: 3, // Costante!
			colorsCliccatoriDaMostrare: ['blue', '#9d46ff', '#006400'],
			idsCliccatoriDaMostrare: [],

			isCliccatoreStatsDialogOpen: false,
			idCliccatoreDaMostrareStats: null,

			tempObject: {
				"hasError": false,
				"messages": [],
				"data": null,
				"tempoDaBattere": 48,
				"totSimulazioniEffettuate": 720,
				"tempoMedio": 34.39,
				"numSimulazioniVinteComplessive": 600,
				"numSimulazioniAbbandonateComplessive": 22,
				"stats_tabella": [
					{
						"classifica": 1,
						"utenteId": 640,
						"username": "DavideFavoriti",
						"tempoMedio": 21.906,
						"numSimulazioniEseguite": 42,
						"numVincenti": 40,
						"percVincenti": "95.2",
						"numAbbandonate": 1,
						"percAbbandonate": "2.4"
					},
					{
						"classifica": 2,
						"utenteId": 610,
						"username": "Lucs",
						"tempoMedio": 22.862,
						"numSimulazioniEseguite": 59,
						"numVincenti": 59,
						"percVincenti": "100.0",
						"numAbbandonate": 1,
						"percAbbandonate": "1.7"
					},
					{
						"classifica": 3,
						"utenteId": 2333,
						"username": "Sebastiano",
						"tempoMedio": 27.176,
						"numSimulazioniEseguite": 4,
						"numVincenti": 4,
						"percVincenti": "100.0",
						"numAbbandonate": 0,
						"percAbbandonate": "0.0"
					},
					{
						"classifica": 4,
						"utenteId": 612,
						"username": "Francesca",
						"tempoMedio": 27.832,
						"numSimulazioniEseguite": 5,
						"numVincenti": 5,
						"percVincenti": "100.0",
						"numAbbandonate": 0,
						"percAbbandonate": "0.0"
					},
					{
						"classifica": 5,
						"utenteId": 618,
						"username": "Eleonora",
						"tempoMedio": 29.87,
						"numSimulazioniEseguite": 169,
						"numVincenti": 158,
						"percVincenti": "93.5",
						"numAbbandonate": 4,
						"percAbbandonate": "2.4"
					},
					{
						"classifica": 6,
						"utenteId": 783,
						"username": "Edoardo",
						"tempoMedio": 29.972,
						"numSimulazioniEseguite": 41,
						"numVincenti": 38,
						"percVincenti": "92.7",
						"numAbbandonate": 1,
						"percAbbandonate": "2.4"
					},
					{
						"classifica": 7,
						"utenteId": 902,
						"username": "Ginnasios",
						"tempoMedio": 30.426,
						"numSimulazioniEseguite": 18,
						"numVincenti": 17,
						"percVincenti": "94.4",
						"numAbbandonate": 0,
						"percAbbandonate": "0.0"
					},
					{
						"classifica": 8,
						"utenteId": 615,
						"username": "Elena",
						"tempoMedio": 30.619,
						"numSimulazioniEseguite": 71,
						"numVincenti": 68,
						"percVincenti": "95.8",
						"numAbbandonate": 1,
						"percAbbandonate": "1.4"
					},
					{
						"classifica": 9,
						"utenteId": 628,
						"username": "Rita",
						"tempoMedio": 31.602,
						"numSimulazioniEseguite": 71,
						"numVincenti": 68,
						"percVincenti": "95.8",
						"numAbbandonate": 0,
						"percAbbandonate": "0.0"
					},
					{
						"classifica": 10,
						"utenteId": 736,
						"username": "Alessandro",
						"tempoMedio": 37.168,
						"numSimulazioniEseguite": 11,
						"numVincenti": 9,
						"percVincenti": "81.8",
						"numAbbandonate": 1,
						"percAbbandonate": "9.1"
					},
					{
						"classifica": 11,
						"utenteId": 617,
						"username": "Lorena",
						"tempoMedio": 37.794,
						"numSimulazioniEseguite": 11,
						"numVincenti": 9,
						"percVincenti": "81.8",
						"numAbbandonate": 0,
						"percAbbandonate": "0.0"
					},
					{
						"classifica": 12,
						"utenteId": 716,
						"username": "Alessia",
						"tempoMedio": 39.354,
						"numSimulazioniEseguite": 15,
						"numVincenti": 13,
						"percVincenti": "86.7",
						"numAbbandonate": 1,
						"percAbbandonate": "6.7"
					},
					{
						"classifica": 13,
						"utenteId": 2282,
						"username": "RobertoT",
						"tempoMedio": 41.044,
						"numSimulazioniEseguite": 3,
						"numVincenti": 2,
						"percVincenti": "66.7",
						"numAbbandonate": 0,
						"percAbbandonate": "0.0"
					},
					{
						"classifica": 14,
						"utenteId": 2283,
						"username": "VanessaC",
						"tempoMedio": 42.874,
						"numSimulazioniEseguite": 19,
						"numVincenti": 15,
						"percVincenti": "78.9",
						"numAbbandonate": 1,
						"percAbbandonate": "5.3"
					},
					{
						"classifica": 15,
						"utenteId": 1257,
						"username": "Sorryemanuel",
						"tempoMedio": 43.328,
						"numSimulazioniEseguite": 13,
						"numVincenti": 10,
						"percVincenti": "76.9",
						"numAbbandonate": 1,
						"percAbbandonate": "7.7"
					},
					{
						"classifica": 16,
						"utenteId": 2301,
						"username": "Fabrizia",
						"tempoMedio": 45.022,
						"numSimulazioniEseguite": 18,
						"numVincenti": 14,
						"percVincenti": "77.8",
						"numAbbandonate": 0,
						"percAbbandonate": "0.0"
					},
					{
						"classifica": 17,
						"utenteId": 619,
						"username": "Paolo",
						"tempoMedio": 47.497,
						"numSimulazioniEseguite": 28,
						"numVincenti": 15,
						"percVincenti": "53.6",
						"numAbbandonate": 2,
						"percAbbandonate": "7.1"
					},
					{
						"classifica": 18,
						"utenteId": 2317,
						"username": "Daniele",
						"tempoMedio": 49.698,
						"numSimulazioniEseguite": 93,
						"numVincenti": 55,
						"percVincenti": "59.1",
						"numAbbandonate": 5,
						"percAbbandonate": "5.4"
					},
					{
						"classifica": 19,
						"utenteId": 2529,
						"username": "Atena",
						"tempoMedio": 81.024,
						"numSimulazioniEseguite": 7,
						"numVincenti": 1,
						"percVincenti": "14.3",
						"numAbbandonate": 3,
						"percAbbandonate": "42.9"
					},
					{
						"classifica": 20,
						"utenteId": 895,
						"username": "Amina",
						"tempoMedio": null,
						"numSimulazioniEseguite": 0,
						"numVincenti": 0,
						"percVincenti": "0",
						"numAbbandonate": 0,
						"percAbbandonate": "0"
					},
					{
						"classifica": 21,
						"utenteId": 2273,
						"username": "AndreaV",
						"tempoMedio": null,
						"numSimulazioniEseguite": 0,
						"numVincenti": 0,
						"percVincenti": "0",
						"numAbbandonate": 0,
						"percAbbandonate": "0"
					},
					{
						"classifica": 22,
						"utenteId": 663,
						"username": "Barbara",
						"tempoMedio": null,
						"numSimulazioniEseguite": 0,
						"numVincenti": 0,
						"percVincenti": "0",
						"numAbbandonate": 0,
						"percAbbandonate": "0"
					},
					{
						"classifica": 23,
						"utenteId": 715,
						"username": "Carmine",
						"tempoMedio": null,
						"numSimulazioniEseguite": 0,
						"numVincenti": 0,
						"percVincenti": "0",
						"numAbbandonate": 0,
						"percAbbandonate": "0"
					},
					{
						"classifica": 24,
						"utenteId": 2324,
						"username": "Daniela",
						"tempoMedio": null,
						"numSimulazioniEseguite": 0,
						"numVincenti": 0,
						"percVincenti": "0",
						"numAbbandonate": 0,
						"percAbbandonate": "0"
					},
					{
						"classifica": 25,
						"utenteId": 717,
						"username": "DavideM",
						"tempoMedio": null,
						"numSimulazioniEseguite": 0,
						"numVincenti": 0,
						"percVincenti": "0",
						"numAbbandonate": 0,
						"percAbbandonate": "0"
					},
					{
						"classifica": 26,
						"utenteId": 641,
						"username": "ElenaZavagli",
						"tempoMedio": null,
						"numSimulazioniEseguite": 0,
						"numVincenti": 0,
						"percVincenti": "0",
						"numAbbandonate": 0,
						"percAbbandonate": "0"
					},
					{
						"classifica": 27,
						"utenteId": 629,
						"username": "Enrico",
						"tempoMedio": null,
						"numSimulazioniEseguite": 0,
						"numVincenti": 0,
						"percVincenti": "0",
						"numAbbandonate": 0,
						"percAbbandonate": "0"
					},
					{
						"classifica": 28,
						"utenteId": 2285,
						"username": "Fabiola",
						"tempoMedio": null,
						"numSimulazioniEseguite": 0,
						"numVincenti": 0,
						"percVincenti": "0",
						"numAbbandonate": 0,
						"percAbbandonate": "0"
					},
					{
						"classifica": 29,
						"utenteId": 611,
						"username": "Giacomo",
						"tempoMedio": null,
						"numSimulazioniEseguite": 0,
						"numVincenti": 0,
						"percVincenti": "0",
						"numAbbandonate": 0,
						"percAbbandonate": "0"
					},
					{
						"classifica": 30,
						"utenteId": 479,
						"username": "GiannaEsposito",
						"tempoMedio": null,
						"numSimulazioniEseguite": 0,
						"numVincenti": 0,
						"percVincenti": "0",
						"numAbbandonate": 0,
						"percAbbandonate": "0"
					},
					{
						"classifica": 31,
						"utenteId": 485,
						"username": "GiuseppeDiChiara",
						"tempoMedio": null,
						"numSimulazioniEseguite": 0,
						"numVincenti": 0,
						"percVincenti": "0",
						"numAbbandonate": 0,
						"percAbbandonate": "0"
					},
					{
						"classifica": 32,
						"utenteId": 2437,
						"username": "Iris",
						"tempoMedio": null,
						"numSimulazioniEseguite": 0,
						"numVincenti": 0,
						"percVincenti": "0",
						"numAbbandonate": 0,
						"percAbbandonate": "0"
					},
					{
						"classifica": 33,
						"utenteId": 622,
						"username": "M4xP",
						"tempoMedio": null,
						"numSimulazioniEseguite": 0,
						"numVincenti": 0,
						"percVincenti": "0",
						"numAbbandonate": 0,
						"percAbbandonate": "0"
					},
					{
						"classifica": 34,
						"utenteId": 2401,
						"username": "Maria",
						"tempoMedio": null,
						"numSimulazioniEseguite": 0,
						"numVincenti": 0,
						"percVincenti": "0",
						"numAbbandonate": 0,
						"percAbbandonate": "0"
					},
					{
						"classifica": 35,
						"utenteId": 639,
						"username": "Marilena",
						"tempoMedio": null,
						"numSimulazioniEseguite": 0,
						"numVincenti": 0,
						"percVincenti": "0",
						"numAbbandonate": 0,
						"percAbbandonate": "0"
					},
					{
						"classifica": 36,
						"utenteId": 2462,
						"username": "Micaela",
						"tempoMedio": null,
						"numSimulazioniEseguite": 0,
						"numVincenti": 0,
						"percVincenti": "0",
						"numAbbandonate": 0,
						"percAbbandonate": "0"
					},
					{
						"classifica": 37,
						"utenteId": 664,
						"username": "Mihana",
						"tempoMedio": null,
						"numSimulazioniEseguite": 0,
						"numVincenti": 0,
						"percVincenti": "0",
						"numAbbandonate": 0,
						"percAbbandonate": "0"
					},
					{
						"classifica": 38,
						"utenteId": 662,
						"username": "Riccardo",
						"tempoMedio": null,
						"numSimulazioniEseguite": 0,
						"numVincenti": 0,
						"percVincenti": "0",
						"numAbbandonate": 0,
						"percAbbandonate": "0"
					},
					{
						"classifica": 39,
						"utenteId": 2284,
						"username": "RosaA",
						"tempoMedio": null,
						"numSimulazioniEseguite": 0,
						"numVincenti": 0,
						"percVincenti": "0",
						"numAbbandonate": 0,
						"percAbbandonate": "0"
					},
					{
						"classifica": 40,
						"utenteId": 625,
						"username": "Rosanna",
						"tempoMedio": null,
						"numSimulazioniEseguite": 0,
						"numVincenti": 0,
						"percVincenti": "0",
						"numAbbandonate": 0,
						"percAbbandonate": "0"
					},
					{
						"classifica": 41,
						"utenteId": 784,
						"username": "Sabrina",
						"tempoMedio": null,
						"numSimulazioniEseguite": 0,
						"numVincenti": 0,
						"percVincenti": "0",
						"numAbbandonate": 0,
						"percAbbandonate": "0"
					},
					{
						"classifica": 42,
						"utenteId": 2334,
						"username": "SerenaT",
						"tempoMedio": null,
						"numSimulazioniEseguite": 0,
						"numVincenti": 0,
						"percVincenti": "0",
						"numAbbandonate": 0,
						"percAbbandonate": "0"
					},
					{
						"classifica": 43,
						"utenteId": 2286,
						"username": "StefanoT",
						"tempoMedio": null,
						"numSimulazioniEseguite": 0,
						"numVincenti": 0,
						"percVincenti": "0",
						"numAbbandonate": 0,
						"percAbbandonate": "0"
					},
					{
						"classifica": 44,
						"utenteId": 621,
						"username": "ZakClick",
						"tempoMedio": null,
						"numSimulazioniEseguite": 0,
						"numVincenti": 0,
						"percVincenti": "0",
						"numAbbandonate": 0,
						"percAbbandonate": "0"
					}
				],
				"tempi_medi_squadra": [
					48.57825,
					44.996750000000006,
					43.7735,
					42.510000000000005,
					42.81725,
					41.6275,
					40.068,
					39.859,
					39.79075,
					39.71625,
					39.875,
					39.585,
					39.198750000000004,
					39.1295,
					38.9955,
					38.982,
					38.3565,
					37.977000000000004,
					37.693,
					37.47025000000001,
					37.33175,
					37.2985,
					36.85875,
					36.5035,
					36.558,
					36.787,
					36.7145,
					36.445499999999996,
					36.22175,
					36.054249999999996,
					35.973749999999995,
					35.84425,
					35.882,
					35.988,
					36.02275,
					36.02875,
					36.065,
					36.35425,
					36.18025,
					35.98,
					36.07175,
					36.028999999999996,
					35.7905,
					35.6445,
					35.635,
					35.567750000000004,
					35.498999999999995,
					35.7635,
					35.736000000000004,
					35.6415,
					35.62225,
					35.33225,
					35.20675,
					35.1455,
					35.21625,
					35.13675,
					35.06275,
					34.9645,
					34.91925,
					34.994749999999996
				],
				"tempi_medi_cliccatori_squadra": {
					"615": [
						{
							"tempo": 38.972,
							"media": 38.972
						},
						{
							"tempo": 57.722,
							"media": 48.347
						},
						{
							"tempo": 22.096,
							"media": 39.596
						},
						{
							"tempo": 26.381,
							"media": 36.292
						},
						{
							"tempo": 31.563,
							"media": 35.346
						},
						{
							"tempo": 26.826,
							"media": 33.926
						},
						{
							"tempo": 28.52,
							"media": 33.154
						},
						{
							"tempo": 33.8,
							"media": 33.235
						},
						{
							"tempo": 38.019,
							"media": 33.766
						},
						{
							"tempo": 26.959,
							"media": 33.085
						},
						{
							"tempo": 22.373,
							"media": 32.112
						},
						{
							"tempo": 35.738,
							"media": 32.414
						},
						{
							"tempo": 45.715,
							"media": 33.437
						},
						{
							"tempo": 31.923,
							"media": 33.329
						},
						{
							"tempo": 41.533,
							"media": 33.876
						},
						{
							"tempo": 20.246,
							"media": 33.024
						},
						{
							"tempo": 23.654,
							"media": 32.473
						},
						{
							"tempo": 31.921,
							"media": 32.442
						},
						{
							"tempo": 31.89,
							"media": 32.413
						},
						{
							"tempo": 27.675,
							"media": 32.176
						},
						{
							"tempo": 19.234,
							"media": 31.56
						},
						{
							"tempo": 32.616,
							"media": 31.608
						},
						{
							"tempo": 18.734,
							"media": 31.048
						},
						{
							"tempo": 29.976,
							"media": 31.003
						},
						{
							"tempo": 36.612,
							"media": 31.228
						},
						{
							"tempo": 40.448,
							"media": 31.582
						},
						{
							"tempo": 36.75,
							"media": 31.774
						},
						{
							"tempo": 21.557,
							"media": 31.409
						},
						{
							"tempo": 23.448,
							"media": 31.134
						},
						{
							"tempo": 31.389,
							"media": 31.143
						},
						{
							"tempo": 22.978,
							"media": 30.879
						},
						{
							"tempo": 25.242,
							"media": 30.703
						},
						{
							"tempo": 50.202,
							"media": 31.294
						},
						{
							"tempo": 18.184,
							"media": 30.909
						},
						{
							"tempo": 30.693,
							"media": 30.902
						},
						{
							"tempo": 19.118,
							"media": 30.575
						},
						{
							"tempo": 32.717,
							"media": 30.633
						},
						{
							"tempo": 21.111,
							"media": 30.382
						},
						{
							"tempo": 21.693,
							"media": 30.16
						},
						{
							"tempo": 18.357,
							"media": 29.865
						},
						{
							"tempo": 33.558,
							"media": 29.955
						},
						{
							"tempo": 32.936,
							"media": 30.026
						},
						{
							"tempo": 15.874,
							"media": 29.696
						},
						{
							"tempo": 14.665,
							"media": 29.355
						},
						{
							"tempo": 21.19,
							"media": 29.173
						},
						{
							"tempo": 45.258,
							"media": 29.523
						},
						{
							"tempo": 29.942,
							"media": 29.532
						},
						{
							"tempo": 87.162,
							"media": 30.733
						},
						{
							"tempo": 30.72,
							"media": 30.732
						},
						{
							"tempo": 19.53,
							"media": 30.508
						},
						{
							"tempo": 43.357,
							"media": 30.76
						},
						{
							"tempo": 17.905,
							"media": 30.513
						},
						{
							"tempo": 25.141,
							"media": 30.412
						},
						{
							"tempo": 23.122,
							"media": 30.277
						},
						{
							"tempo": 24.704,
							"media": 30.175
						},
						{
							"tempo": 33.156,
							"media": 30.229
						},
						{
							"tempo": 26.816,
							"media": 30.169
						},
						{
							"tempo": 25.85,
							"media": 30.094
						},
						{
							"tempo": 29.13,
							"media": 30.078
						},
						{
							"tempo": 46.126,
							"media": 30.345
						}
					],
					"618": [
						{
							"tempo": 31.986,
							"media": 31.986
						},
						{
							"tempo": 40.586,
							"media": 36.286
						},
						{
							"tempo": 37.662,
							"media": 36.745
						},
						{
							"tempo": 33.032,
							"media": 35.816
						},
						{
							"tempo": 52.109,
							"media": 39.075
						},
						{
							"tempo": 25.146,
							"media": 36.753
						},
						{
							"tempo": 25.113,
							"media": 35.091
						},
						{
							"tempo": 37.939,
							"media": 35.447
						},
						{
							"tempo": 28.075,
							"media": 34.627
						},
						{
							"tempo": 40.963,
							"media": 35.261
						},
						{
							"tempo": 23.355,
							"media": 34.179
						},
						{
							"tempo": 35.139,
							"media": 34.259
						},
						{
							"tempo": 22.357,
							"media": 33.343
						},
						{
							"tempo": 23.086,
							"media": 32.611
						},
						{
							"tempo": 26.844,
							"media": 32.226
						},
						{
							"tempo": 33.948,
							"media": 32.334
						},
						{
							"tempo": 26.786,
							"media": 32.007
						},
						{
							"tempo": 30.272,
							"media": 31.911
						},
						{
							"tempo": 23.905,
							"media": 31.49
						},
						{
							"tempo": 34.096,
							"media": 31.62
						},
						{
							"tempo": 33.197,
							"media": 31.695
						},
						{
							"tempo": 29.212,
							"media": 31.582
						},
						{
							"tempo": 28.071,
							"media": 31.43
						},
						{
							"tempo": 23.836,
							"media": 31.113
						},
						{
							"tempo": 30.698,
							"media": 31.097
						},
						{
							"tempo": 28.553,
							"media": 30.999
						},
						{
							"tempo": 22.222,
							"media": 30.674
						},
						{
							"tempo": 26.834,
							"media": 30.537
						},
						{
							"tempo": 26.387,
							"media": 30.393
						},
						{
							"tempo": 25.982,
							"media": 30.246
						},
						{
							"tempo": 31.062,
							"media": 30.273
						},
						{
							"tempo": 33.824,
							"media": 30.384
						},
						{
							"tempo": 22.949,
							"media": 30.158
						},
						{
							"tempo": 25.799,
							"media": 30.03
						},
						{
							"tempo": 31.848,
							"media": 30.082
						},
						{
							"tempo": 34.207,
							"media": 30.197
						},
						{
							"tempo": 48.551,
							"media": 30.693
						},
						{
							"tempo": 26.621,
							"media": 30.586
						},
						{
							"tempo": 26.058,
							"media": 30.47
						},
						{
							"tempo": 22.033,
							"media": 30.259
						},
						{
							"tempo": 22.628,
							"media": 30.072
						},
						{
							"tempo": 34.367,
							"media": 30.175
						},
						{
							"tempo": 26.657,
							"media": 30.093
						},
						{
							"tempo": 32.063,
							"media": 30.138
						},
						{
							"tempo": 32.363,
							"media": 30.187
						},
						{
							"tempo": 24.972,
							"media": 30.074
						},
						{
							"tempo": 26.188,
							"media": 29.991
						},
						{
							"tempo": 23.832,
							"media": 29.863
						},
						{
							"tempo": 29.248,
							"media": 29.85
						},
						{
							"tempo": 31.229,
							"media": 29.878
						},
						{
							"tempo": 24.481,
							"media": 29.772
						},
						{
							"tempo": 20.43,
							"media": 29.592
						},
						{
							"tempo": 23.284,
							"media": 29.473
						},
						{
							"tempo": 24.261,
							"media": 29.377
						},
						{
							"tempo": 35.406,
							"media": 29.486
						},
						{
							"tempo": 37.364,
							"media": 29.627
						},
						{
							"tempo": 26.887,
							"media": 29.579
						},
						{
							"tempo": 36.582,
							"media": 29.7
						},
						{
							"tempo": 30.371,
							"media": 29.711
						},
						{
							"tempo": 39.741,
							"media": 29.878
						}
					],
					"628": [
						{
							"tempo": 37.92,
							"media": 37.92
						},
						{
							"tempo": 22.731,
							"media": 30.325
						},
						{
							"tempo": 29.832,
							"media": 30.161
						},
						{
							"tempo": 36.995,
							"media": 31.869
						},
						{
							"tempo": 27.965,
							"media": 31.088
						},
						{
							"tempo": 41.313,
							"media": 32.792
						},
						{
							"tempo": 38.397,
							"media": 33.593
						},
						{
							"tempo": 24.792,
							"media": 32.493
						},
						{
							"tempo": 30.081,
							"media": 32.225
						},
						{
							"tempo": 29.895,
							"media": 31.992
						},
						{
							"tempo": 32.831,
							"media": 32.068
						},
						{
							"tempo": 34.095,
							"media": 32.237
						},
						{
							"tempo": 28.653,
							"media": 31.961
						},
						{
							"tempo": 37.917,
							"media": 32.387
						},
						{
							"tempo": 22.373,
							"media": 31.719
						},
						{
							"tempo": 28.644,
							"media": 31.527
						},
						{
							"tempo": 18.368,
							"media": 30.753
						},
						{
							"tempo": 20.225,
							"media": 30.168
						},
						{
							"tempo": 30.873,
							"media": 30.205
						},
						{
							"tempo": 21.06,
							"media": 29.748
						},
						{
							"tempo": 42.699,
							"media": 30.365
						},
						{
							"tempo": 22.183,
							"media": 29.993
						},
						{
							"tempo": 30.2,
							"media": 30.002
						},
						{
							"tempo": 17.005,
							"media": 29.46
						},
						{
							"tempo": 40.188,
							"media": 29.889
						},
						{
							"tempo": 33.289,
							"media": 30.02
						},
						{
							"tempo": 42.323,
							"media": 30.476
						},
						{
							"tempo": 28.922,
							"media": 30.42
						},
						{
							"tempo": 24.716,
							"media": 30.224
						},
						{
							"tempo": 18.274,
							"media": 29.825
						},
						{
							"tempo": 33.927,
							"media": 29.958
						},
						{
							"tempo": 25.296,
							"media": 29.812
						},
						{
							"tempo": 26.928,
							"media": 29.724
						},
						{
							"tempo": 39.067,
							"media": 29.999
						},
						{
							"tempo": 42.748,
							"media": 30.363
						},
						{
							"tempo": 36.216,
							"media": 30.526
						},
						{
							"tempo": 29.335,
							"media": 30.494
						},
						{
							"tempo": 105.819,
							"media": 32.476
						},
						{
							"tempo": 33.949,
							"media": 32.514
						},
						{
							"tempo": 35.383,
							"media": 32.586
						},
						{
							"tempo": 38.278,
							"media": 32.724
						},
						{
							"tempo": 34.54,
							"media": 32.768
						},
						{
							"tempo": 26.025,
							"media": 32.611
						},
						{
							"tempo": 24.754,
							"media": 32.432
						},
						{
							"tempo": 30.914,
							"media": 32.399
						},
						{
							"tempo": 18.712,
							"media": 32.101
						},
						{
							"tempo": 24.751,
							"media": 31.945
						},
						{
							"tempo": 41.64,
							"media": 32.147
						},
						{
							"tempo": 23.132,
							"media": 31.963
						},
						{
							"tempo": 29.823,
							"media": 31.92
						},
						{
							"tempo": 34.489,
							"media": 31.97
						},
						{
							"tempo": 14.193,
							"media": 31.628
						},
						{
							"tempo": 33.833,
							"media": 31.67
						},
						{
							"tempo": 25.396,
							"media": 31.554
						},
						{
							"tempo": 52.536,
							"media": 31.935
						},
						{
							"tempo": 19.968,
							"media": 31.722
						},
						{
							"tempo": 25.901,
							"media": 31.619
						},
						{
							"tempo": 24.794,
							"media": 31.502
						},
						{
							"tempo": 25.168,
							"media": 31.394
						},
						{
							"tempo": 38.749,
							"media": 31.517
						}
					],
					"2317": [
						{
							"tempo": 85.435,
							"media": 85.435
						},
						{
							"tempo": 44.624,
							"media": 65.029
						},
						{
							"tempo": 75.716,
							"media": 68.592
						},
						{
							"tempo": 58.478,
							"media": 66.063
						},
						{
							"tempo": 64.548,
							"media": 65.76
						},
						{
							"tempo": 49.433,
							"media": 63.039
						},
						{
							"tempo": 30.803,
							"media": 58.434
						},
						{
							"tempo": 57.052,
							"media": 58.261
						},
						{
							"tempo": 60.821,
							"media": 58.545
						},
						{
							"tempo": 58.359,
							"media": 58.527
						},
						{
							"tempo": 87.287,
							"media": 61.141
						},
						{
							"tempo": 40.614,
							"media": 59.43
						},
						{
							"tempo": 41.539,
							"media": 58.054
						},
						{
							"tempo": 59.965,
							"media": 58.191
						},
						{
							"tempo": 57.748,
							"media": 58.161
						},
						{
							"tempo": 72.271,
							"media": 59.043
						},
						{
							"tempo": 44.601,
							"media": 58.193
						},
						{
							"tempo": 43.685,
							"media": 57.387
						},
						{
							"tempo": 43.653,
							"media": 56.664
						},
						{
							"tempo": 50.111,
							"media": 56.337
						},
						{
							"tempo": 43.116,
							"media": 55.707
						},
						{
							"tempo": 62.388,
							"media": 56.011
						},
						{
							"tempo": 31.717,
							"media": 54.955
						},
						{
							"tempo": 42.552,
							"media": 54.438
						},
						{
							"tempo": 43.952,
							"media": 54.018
						},
						{
							"tempo": 67.764,
							"media": 54.547
						},
						{
							"tempo": 37.995,
							"media": 53.934
						},
						{
							"tempo": 39.43,
							"media": 53.416
						},
						{
							"tempo": 45.282,
							"media": 53.136
						},
						{
							"tempo": 49.153,
							"media": 53.003
						},
						{
							"tempo": 46.261,
							"media": 52.785
						},
						{
							"tempo": 42.937,
							"media": 52.478
						},
						{
							"tempo": 48.335,
							"media": 52.352
						},
						{
							"tempo": 74.876,
							"media": 53.014
						},
						{
							"tempo": 43.544,
							"media": 52.744
						},
						{
							"tempo": 55.367,
							"media": 52.817
						},
						{
							"tempo": 38.878,
							"media": 52.44
						},
						{
							"tempo": 34.688,
							"media": 51.973
						},
						{
							"tempo": 36.537,
							"media": 51.577
						},
						{
							"tempo": 36.905,
							"media": 51.21
						},
						{
							"tempo": 64.556,
							"media": 51.536
						},
						{
							"tempo": 35.221,
							"media": 51.147
						},
						{
							"tempo": 34.579,
							"media": 50.762
						},
						{
							"tempo": 45.948,
							"media": 50.653
						},
						{
							"tempo": 56.417,
							"media": 50.781
						},
						{
							"tempo": 41.225,
							"media": 50.573
						},
						{
							"tempo": 48.454,
							"media": 50.528
						},
						{
							"tempo": 40.104,
							"media": 50.311
						},
						{
							"tempo": 54.653,
							"media": 50.399
						},
						{
							"tempo": 43.417,
							"media": 50.26
						},
						{
							"tempo": 36.346,
							"media": 49.987
						},
						{
							"tempo": 29.683,
							"media": 49.596
						},
						{
							"tempo": 32.429,
							"media": 49.272
						},
						{
							"tempo": 54.774,
							"media": 49.374
						},
						{
							"tempo": 43.591,
							"media": 49.269
						},
						{
							"tempo": 32.467,
							"media": 48.969
						},
						{
							"tempo": 44.099,
							"media": 48.884
						},
						{
							"tempo": 30.218,
							"media": 48.562
						},
						{
							"tempo": 44.564,
							"media": 48.494
						},
						{
							"tempo": 33.167,
							"media": 48.239
						}
					]
				},
				"tempi_medi_azienda": [
					37.396,
					35.331,
					35.418,
					35.001,
					34.893,
					34.553,
					34.145,
					34.038,
					33.847,
					33.65,
					33.615,
					33.657,
					33.428,
					33.286,
					33.144,
					33.116,
					32.918,
					32.82,
					32.699,
					32.653,
					32.505,
					32.298,
					32.139,
					32.031,
					31.938,
					31.909,
					31.843,
					31.788,
					31.695,
					31.628,
					31.545,
					31.441,
					31.328,
					31.341,
					31.308,
					31.31,
					31.243,
					31.25,
					31.15,
					31.106,
					31.077,
					31.01,
					31.013,
					30.931,
					30.885,
					30.827,
					30.802,
					30.771,
					30.775,
					30.794,
					30.732,
					30.688,
					30.624,
					30.598,
					30.576,
					30.511,
					30.509,
					30.475,
					30.421,
					30.429
				]
			}
		};
	},
	async created() {
		this.getBandi();
		await this.getSquadre();
		this.getStatsSquadra();
	},
	watch: {
		'idSquadraSelezionata': function () {
			this.idsCliccatoriDaMostrare = [];
		}
	},
	methods: {
		getBandi() {
			this.isLoadingBandi = true;
			// this.isLoadingStats = true;
			return axios
				.get('/getBandi')
				.then(response => {
					this.bandoId = response.data.idBandoSelezionato;
					this.bandi = response.data.bandi;
				})
				.finally(() => {
					this.isLoadingBandi = false;
				})

		},
		getSquadre: function () {
			// Se sono Admin restituisce tutte le Squadre (la prima: id=0 è Senza Squadra -> Cliccatori senza Squadra)
			// Se sono Teamleader restituisce solo la mia Squadra
			this.isLoadingSquadre = true;

			return axios.get("/teams")
				.then(response => {
					if (response.data.hasError) {
						this.alertType = "error";
						this.message = response.data.messages[0];
					} else {
						this.squadre = response.data.data;

						// Se sono Admin, aggiungo anche Senza Squadra:
						if (this.computedAmIAdmin) {
							this.squadre.unshift({
								id: 0,
								nome: "Senza Squadra"
							});
						}

						this.idSquadraSelezionata = this.squadre[0].id;

						// se chiamo il compenente passando com prop l'id della squadra
						if (this.idSquadra !== undefined) {
							this.idSquadraSelezionata = this.idSquadra;
						}
					}
				})
				.catch(error => {
					this.alertType = "error";
					this.message = "Errore recuperando le squadre";
				})
				.finally(() => {
					this.isLoadingSquadre = false;
				});

		},
		getStatsSquadra: function () {
			if (this.isLoadingStats) return;

			this.isLoadingStats = true;

			this.tableStatsCliccatore.splice(0, this.tableStatsCliccatore.length);

			let q = `/statistiche/squadre/${this.idSquadraSelezionata}`;

			axios
				.get(q, {
					params: {
						data_dal: this.dateDal,
						data_al: this.dateAl,
						// cliccatoriDaMostrare: this.idsCliccatoriDaMostrare,
						bando_id: this.bandoId
					}
				})
				.then(response => {
					if (response.data.hasError) {
						this.alertType = "error";
						this.message = response.data.messages[0];
					} else {

						// response.data = this.tempObject;

						this.tempoDaBattere = parseFloat(response.data.tempoDaBattere);

						this.numSimulazioniComplessive = parseInt(response.data.totSimulazioniEffettuate);
						this.tempoMedioComplessivo = parseFloat(response.data.tempoMedio);

						this.numSimulazioniVinteComplessive = parseInt(response.data.numSimulazioniVinteComplessive);
						if (isNaN(this.numSimulazioniVinteComplessive)) this.numSimulazioniVinteComplessive = 0;

						this.numSimulazioniAbbandonateComplessive = parseInt(response.data.numSimulazioniAbbandonateComplessive);
						if (isNaN(this.numSimulazioniAbbandonateComplessive)) this.numSimulazioniAbbandonateComplessive = 0;

						this.pieChart = [
							this.numSimulazioniVinteComplessive,
							this.numSimulazioniComplessive - this.numSimulazioniVinteComplessive - this.numSimulazioniAbbandonateComplessive,
							this.numSimulazioniAbbandonateComplessive
						];

						// Aggiungo ad ogni cliccatore un "checkbox_value" a false se il suo id non è presente nell'elenco degli ID da mostrare in grafico:

						this.tableStatsCliccatore = response.data.stats_tabella;
						let self = this;
						this.tableStatsCliccatore.forEach((elem) => {
							if (self.idsCliccatoriDaMostrare.includes(elem.utenteId)) elem.checkbox_value = true;
							else elem.checkbox_value = false;
						})

						// Dati per il grafico:
						this.tempiMediSquadra = response.data.tempi_medi_squadra;
						this.tempiMediAzienda = response.data.tempi_medi_azienda;
						this.tempiMediCliccatoriSquadra = response.data.tempi_medi_cliccatori_squadra;
						// console.log(this.tempiMediCliccatoriSquadra);

						// let tutteLeSquadreTempiMedi = [];

						let tempoDaBattere = []; // Serve a generare la linea

						let counter = [];

						let medieCliccatoriDaMostrare = new Array(this.limitCliccatoriDaMostrare); // Anche se poi i cliccatori magari sono 1 o 2
						for (let i = 0; i < this.limitCliccatoriDaMostrare; i++) {
							medieCliccatoriDaMostrare[i] = [];
						}

						// response.data.stats_grafico.forEach(function (riga, index) {
						this.tempiMediSquadra.forEach(function (riga, index) {
							// tempiMediSquadra.push(parseFloat(riga.mediaSquadra));

							// tutteLeSquadreTempiMedi.push(parseFloat(riga.mediaTutteLeSquadre));
							//
							// riga.mediaCliccatoriDaMostrare.forEach((mediaCumulataAttualeCliccatoreDaMostrare, index) => {
							// 	medieCliccatoriDaMostrare[index].push(mediaCumulataAttualeCliccatoreDaMostrare);
							// })

							tempoDaBattere.push(self.tempoDaBattere);

							counter.push(""); // Senza di questo non funziona!
						})

						this.dataLineChart = {
							labels: counter,
							datasets: [
								{
									label: 'Tempo da battere',
									backgroundColor: 'rgba(5, 141, 199, .1)',//'#00ff0022',
									pointBackgroundColor: '#058dc7',
									pointRadius: 0,
									borderWidth: 1,
									// pointBorderColor: '#00ff00',
									borderColor: '#058dc7',
									data: tempoDaBattere
								},
								{
									label: 'Media della Squadra (Solo Cliccatori con almeno 60 simulazioni svolte)',
									backgroundColor: '#0000ff00', // trasparente
									pointBackgroundColor: '#e69024',
									pointRadius: 1.3,
									borderWidth: 1,
									borderColor: '#e69024',
									// pointBorderColor: '#0000ff', // Bordino del pallino
									data: this.tempiMediSquadra
								},
							]
						};

						if (this.computedAmIAdmin) {
							this.dataLineChart.datasets.push(
								{
									label: 'Media dell\'Azienda (Solo Cliccatori con almeno 60 simulazioni svolte)',
									backgroundColor: '#0000ff00', // trasparente
									pointBackgroundColor: '#e53926',
									pointRadius: 1.3,
									borderWidth: 1,
									borderColor: '#e53926',
									// pointBorderColor: '#0000ff', // Bordino del pallino
									data: this.tempiMediAzienda
								}
							)
						}

						this.originalDatasets = Object.assign([], this.dataLineChart.datasets);

						// for (let i = 0; i < this.idsCliccatoriDaMostrare.length; i++) {
						// 	if (medieCliccatoriDaMostrare[i].length != 0) {
						// 		let username = null;
						// 		this.tableStatsCliccatore.some((cliccatore) => {
						// 			// Prendo gli username dei cliccatori
						// 			if (cliccatore.utenteId === self.idsCliccatoriDaMostrare[i]) {
						// 				username = cliccatore.username;
						// 				return true;
						// 			}
						// 		});
						// 		this.dataLineChart.datasets.push({
						// 			label: `${username}`,
						// 			backgroundColor: '#0000ff00', // trasparente
						// 			borderColor: `${this.colorsCliccatoriDaMostrare[i]}`,
						// 			pointRadius: 1.3,
						// 			borderWidth: 1,
						// 			// pointBorderColor: '#0000ff', // Bordino del pallino
						// 			data: medieCliccatoriDaMostrare[i]
						// 		})
						// 	}
						// }

						this.options = {
							title: {
								display: false
							},
							scales: {
								yAxes: [{
									scaleLabel: {
										display: true,
										labelString: 'Tempi (secondi)',
										fontSize: 16,
										fontFamily: "cursive",
										fontColor: '#6d94cd'
									},
									ticks: {
										beginAtZero: true
									},
									gridLines: {
										display: true
									}
								}],
								xAxes: [{
									display: true,
									scaleLabel: {
										display: true,
										labelString: '# Simulazioni',
										fontColor: '#6d94cd',
										fontFamily: "cursive",
										fontSize: 14,
										padding: {
											top: 0
										}
									},
									gridLines: {
										display: false
									}
								}]
							},
							legend: {
								display: true
							},
							responsive: true,
							maintainAspectRatio: false
						}
					}
				})
				.catch(error => {
					console.log(error);
					this.alertType = "error";
					this.message = "Errore recuperando le statistiche della Squadra";
				})
				.finally(() => {
					this.isLoadingStats = false;
				});

		},
		mostraNascondiGraficoCliccatore: function (cliccatoreId) {
			// Ridondanza necessaria (necessario avere sia idsCliccatoriDaMostrare sia il valore nel singolo cliccatore)
			// l'elemento v-checkbox si occupa di mettere a true/false il bool associato al v-model
			if (this.idsCliccatoriDaMostrare.includes(cliccatoreId)) {
				this.idsCliccatoriDaMostrare.splice(this.idsCliccatoriDaMostrare.indexOf(cliccatoreId), 1);
				this.updateCliccatoriNelGrafico();
				// this.getStatsSquadra();
			} else if (this.idsCliccatoriDaMostrare.length < this.limitCliccatoriDaMostrare) {
				this.idsCliccatoriDaMostrare.push(cliccatoreId);
				this.updateCliccatoriNelGrafico();
				// this.getStatsSquadra();
			} else {
				this.alertType = 'error';
				this.message = `Non può mostrare più di ${this.limitCliccatoriDaMostrare} cliccatori per volta`;
			}
		},
		updateCliccatoriNelGrafico() {
			this.dataLineChart.datasets = Object.assign([], this.originalDatasets);
			this.idsCliccatoriDaMostrare.forEach((idCliccatore, index) => {
				const username = this.tableStatsCliccatore.find(cliccatore => cliccatore.utenteId === idCliccatore).username;
				const tempiMediCliccatoreSquadra = this.tempiMediCliccatoriSquadra[idCliccatore].map(x => x.media);
				// this.tableStatsCliccatore.some(cliccatore => {
				// 	// Prendo gli username dei cliccatori
				// 	if (cliccatore.utenteId === idCliccatore) {
				// 		console.log(this.tempiMediCliccatoriSquadra[idCliccatore])
				// 		username = cliccatore.username;
				// 		return true;
				// 	}
				// });
				// TODO: rimuovere il dataset quando si spegne l'interruttore
				this.dataLineChart.datasets.push({
					label: `${username}`,
					backgroundColor: '#0000ff00', // trasparente
					borderColor: `${this.colorsCliccatoriDaMostrare[index]}`,
					pointRadius: 1.3,
					borderWidth: 1,
					// pointBorderColor: '#0000ff', // Bordino del pallino
					data: tempiMediCliccatoreSquadra
				})
			})

			this.lineChartKey += 1;
			// console.log(this.dataLineChart)
		},
		showStatsCliccatore: function (idCliccatore) {
			this.idCliccatoreDaMostrareStats = idCliccatore;
			this.isCliccatoreStatsDialogOpen = true;
		},
	}
};
</script>

<style lang="scss" scoped>
._pagina_statistiche_squadre {
	font-family: 'Montserrat', sans-serif !important;
	font-size: 14px;
	color: #6D94CD;
	font-weight: 400;
	line-height: 1.5;
	padding-top: 20px;
}

._medium {
	font-weight: 500;
}

._semi_bold {
	font-weight: 600;
}

::v-deep .statistiche-data-table {
	background-color: #eeeeee;
	color: #434343 !important;

	& .v-data-table-header tr th {
		border-bottom: none !important;
		color: #6d94cd !important;
		// height: 18px;
		// font-size: 15px;
		text-align: center !important;
		// &:not(:nth-child(2)) {
		//   color: #6d94cd;
		// }
		// &:nth-child(2) {
		//   color: #fff;
		//   background-color: #e6901c;
		// }
	}

}

::v-deep .statistiche-data-table ._table_row {
	& td {
		border-bottom: 0 !important;
		font-size: 13px;
		text-align: center;
		height: 40px;

		&.bg_green {
			background-color: #8bba40 !important;
		}

		&.bg_red {
			background-color: #bc2025 !important;
		}
	}

}

::v-deep .statistiche-data-table .v-data-footer {
	color: #434343;
	font-weight: 600;
	border-top: none !important;

	& .v-data-footer__select {
		margin-left: 4% !important;
	}
}
</style>